// 3rd-party modules
import { FloatButton, Typography } from "antd";
import { isMobile } from "react-device-detect";
import { useState } from "react";

// project modules
import SmsPanelRemainingBalance from "../components/sms-pannel/SmsPanelRemainingBalance";
import SmsPanelSentSmsStatistics from "../components/sms-pannel/SmsPanelSentSmsStatistics";
import PaymentTypePickerModal from "../components/sms-pannel/modal/PaymentTypePickerModal";
import useTranslation from "../hooks/TranslationContext";

export default function TextExpressPage() {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);

  const onModalSave = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <Typography.Title level={4}>{t("sms-panel")}</Typography.Title>
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Progress Card */}
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SmsPanelRemainingBalance/>
        </div>

        {/* <div className="p-5 bg-white shadow rounded">
        </div>

        <div className="p-5 bg-white shadow rounded">

        </div> */}
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-6">
        {/* Heatmap Chart Card */}
        <div className="p-5 bg-white shadow rounded col-span-1 md:col-span-2">
          <SmsPanelSentSmsStatistics/>
        </div>
      </div>
      <FloatButton className={isMobile ? "fixed bottom-20" : ""} icon={<icon>add_card</icon>} tooltip={<div>{t("charge")}</div>} onClick={() => setModalOpen(true)}/>
      {isModalOpen && (
        <PaymentTypePickerModal
          open={isModalOpen}
          onSave={onModalSave}
          onCancel={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
